import React from 'react';
import { IconHelp } from '@tabler/icons-react';
import styles from './MHelpIcon.module.css';

interface MHelpIconProps {
  onClick: () => void;
  fixed?: boolean;
}

export const MHelpIcon: React.FC<MHelpIconProps> = ({ onClick, fixed = false }) => {
  return (
    <button 
      className={`${styles.helpIcon} ${fixed ? styles.fixed : ''}`}
      onClick={onClick}
      aria-label="Guided tour"
    >
      <IconHelp size={24} />
    </button>
  );
};
